/**
 * @generated SignedSource<<90ba46c328d68a6c5b35e19916cfe641>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetFileInput = {
  files: ReadonlyArray<FileInput>;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  slideshowDuration?: number | null;
  title?: string | null;
};
export type FileInput = {
  fileId: string;
  pageNumbers?: ReadonlyArray<number> | null;
};
export type OrgSpaceWidgetAddFileMutation$variables = {
  input: CreateWidgetFileInput;
  spaceId: string;
};
export type OrgSpaceWidgetAddFileMutation$data = {
  readonly storecastSpace: {
    readonly createWidgetFile: {
      readonly id: string;
    };
  } | null;
};
export type OrgSpaceWidgetAddFileMutation = {
  response: OrgSpaceWidgetAddFileMutation$data;
  variables: OrgSpaceWidgetAddFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "spaceId"
      }
    ],
    "concreteType": "StorecastSpaceMutation",
    "kind": "LinkedField",
    "name": "storecastSpace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetFile",
        "kind": "LinkedField",
        "name": "createWidgetFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgSpaceWidgetAddFileMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgSpaceWidgetAddFileMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "dcda1acd2b59bdbfe4648bb3c3e0b080",
    "id": null,
    "metadata": {},
    "name": "OrgSpaceWidgetAddFileMutation",
    "operationKind": "mutation",
    "text": "mutation OrgSpaceWidgetAddFileMutation(\n  $spaceId: ID!\n  $input: CreateWidgetFileInput!\n) {\n  storecastSpace(id: $spaceId) {\n    createWidgetFile(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "29baf28a58c81adc585df3a36ec8658f";

export default node;
